<template>
    <div class="container-fluid no-min-height">
        <div class="row">
            <div class="col-12 col-lg-6 offset-lg-3">
                <h2>{{ formData.title }}</h2>

                <div class="position-relative">
                    <transition name="fade">
                        <form v-if="!success" key="form">
                            <TextInput
                                v-model="form.firstName"
                                v-validate="'required'"
                                data-vv-as="Voornaam"
                                :disabled="processing"
                                :error="errors.first('firstName')"
                                :name="'firstName'"
                                :label="language.firstName"
                                :placeholder="language.firstName"
                            ></TextInput>

                            <TextInput
                                v-model="form.lastName"
                                v-validate="'required'"
                                data-vv-as="Achternaam"
                                :disabled="processing"
                                :error="errors.first('lastName')"
                                :name="'lastName'"
                                :label="language.lastName"
                                :placeholder="language.lastName"
                            ></TextInput>

                            <TextInput
                                v-model="form.email"
                                v-validate="'required|email'"
                                data-vv-as="E-mailadres"
                                :disabled="processing"
                                :error="errors.first('email')"
                                :name="'email'"
                                :label="language.email"
                                :placeholder="'naam@provider.com'"
                                :type="'email'"
                            ></TextInput>

                            <TextInput
                                v-model="form.phone"
                                v-validate="{
                                    required: true,
                                    max: 11,
                                    regex: /\d{3,4}[ -]{0,1}\d{6,7}/
                                }"
                                data-vv-as="Telefoonnummer"
                                :disabled="processing"
                                :error="errors.first('phone')"
                                :name="'phone'"
                                :label="language.phone"
                                :placeholder="'0612345678'"
                                :type="'tel'"
                            ></TextInput>

                            <TextAreaInput
                                v-model="form.message"
                                data-vv-as="Bericht"
                                :disabled="processing"
                                :error="errors.first('message')"
                                :name="'message'"
                                :label="language.message"
                                :rows="5"
                                :placeholder="language.messagePlaceholder"
                            ></TextAreaInput>

                            <button
                                class="btn btn-primary float-right mb-1"
                                :disabled="processing"
                                @click.prevent="validateAndSubmit"
                            >
                                {{ language.button }}
                            </button>
                        </form>
                        <div
                            v-else
                            key="successMessage"
                            class="rte"
                            v-html="formData.successMessage"
                        ></div>
                    </transition>
                    <div
                        v-if="!success && error"
                        key="errorMessage"
                        class="rte form-failed"
                        v-html="errorMessageFromApi"
                    ></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import FormSubmissionMixin from '@/js/mixins/form-submission-mixin.js';
import TextInput from '@/components/form/text-input';
import TextAreaInput from '@/components/form/textarea-input';

Vue.use(VueReCaptcha, { siteKey: '6LfB5cMUAAAAAOnv1Nn1d1neosmH_X5xVuUx0zu4' });

export default {
    components: {
        TextInput,
        TextAreaInput
    },

    mixins: [FormSubmissionMixin],

    props: {
        formData: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            form: {
                firstName: '',
                lastName: '',
                email: '',
                message: '',
                contactId: 0
            },
            language: {
                firstName: 'Voornaam',
                lastName: 'Achternaam',
                email: 'E-mailadres',
                phone: 'Telefoonnummer',
                message: 'Bericht',
                messagePlaceholder: 'Vul hier je bericht in...',
                button: 'Verstuur'
            },
            postUrl: '/api/ContactFormApi/Submit'
        };
    },

    computed: {
        errorMessageFromApi() {
            if (!this.errorMessage.length) {
                return this.formData.errorMessage;
            }

            return this.errorMessage;
        }
    },

    created() {
        this.form.contactId = this.formData.contactPerson;

        if (this.formData.language == true) {
            this.language.firstName = 'First name';
            this.language.lastName = 'Last name';
            this.language.email = 'Email address';
            this.language.phone = 'Phone number';
            this.language.message = 'Message';
            this.language.messagePlaceholder = 'Add your message here...';
            this.language.button = 'Send';
        }

        if (
            this.formData.buttonText != null &&
            this.formData.buttonText != ''
        ) {
            this.language.button = this.formData.buttonText;
        }
    }
};
</script>

<style lang="scss">
.grecaptcha-badge {
    display: none;
}

.fade-enter-active,
.fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    transition: opacity 0.5s $easeOutQuad, transform 0.5s $easeOutQuad;
}
.fade-enter {
    opacity: 0;
    transform: translateX(-100%);
}

.fade-leave-to {
    opacity: 0;
    transform: translateX(100%);
}
</style>
